<script lang="ts">
    import type {MenuItem} from 'shared/components/kp-main-menu/types';
    import {exists} from 'shared/utils/custom-utils';
    import {clickOutside} from 'shared/svelte-actions/use.click-outside';
    import {getMainMenuContext} from 'shared/components/kp-main-menu/main-menu-context';
    import {createEventDispatcher, onDestroy} from 'svelte';
    import {get} from 'svelte/store';

    const context = getMainMenuContext();
    const dispatch = createEventDispatcher<{ 'link-click': void }>();

    let menuItems = get(context.items);
    const menuItemsUnsubscribe = context.items.subscribe((currentItems) => menuItems = currentItems);

    onDestroy(() => {
        menuItemsUnsubscribe();
    });

    const handleLinkClick = async (item: MenuItem) => {
        await context.service.performClick(item);
        dispatch('link-click');
    }
</script>

<div class="kp-side-main-menu"
     style="--main-menu-background-color: {context.backgroundColor}; --main-menu-text-color: {context.textColor};"
     use:clickOutside
     on:click-outside>

    <ul class="links-list" role="menu">
        {#each menuItems as menuItem}
            <li class="nav-link">
                <a class="menu-id-{menuItem.id} link-label full-size-anchor"
                   href={context.service.getMenuItemAnchorHref(menuItem)}
                   on:click={() => handleLinkClick(menuItem)}>

                    {menuItem.text}
                </a>

                {#if exists(menuItem.submenu)}
                    <ul class="sub-menu-list">
                        {#each menuItem.submenu as subMenuItem}
                            <li class="sub-menu-item">
                                <a class="menu-id-{subMenuItem.id} full-size-anchor"
                                   href={context.service.getMenuItemAnchorHref(subMenuItem)}
                                   on:click={() => handleLinkClick(subMenuItem)}>

                                    {subMenuItem.text}
                                </a>
                            </li>
                        {/each}
                    </ul>
                {/if}
            </li>
        {/each}
    </ul>
</div>

<style lang="less">
    @import (reference) "bootstrap-less/bootstrap/variables";

    @side-menu-max-width: 360px;
    @vertical-spacing: 14px;

    .kp-side-main-menu {
        width: 80dvw;
        max-width: @side-menu-max-width;
        background-color: var(--main-menu-background-color);
        color: var(--main-menu-text-color);
        overflow-y: auto;

        .nav-link {
            display: flex;
            flex-direction: column;
            padding: @vertical-spacing @padding-large-horizontal;
            border-bottom: 1px solid rgba(255, 255, 255, 0.25);
            gap: 16px;

            &:last-child {
                border-bottom: none;
            }

            .link-label {
                font-weight: bold;
            }

            .full-size-anchor {
                color: inherit;
                text-decoration: none;
                width: 100%;
                height: 100%;
                display: flex;
                align-items: center;
            }

            .sub-menu-list {
                display: flex;
                flex-direction: column;
                gap: @vertical-spacing;
                margin-left: @padding-small-horizontal;
            }
        }
    }
</style>